module.exports = function() {
  return new Worker(__webpack_public_path__ + "fa3be3bfa46e077d3d69.worker.js");
};